import { Box, BoxProps, styled } from '@mui/material'
import { useContextState } from '../../hooks/theme'

const NewCard = styled((props: BoxProps) => <Box {...props} />)(() => {
  const { colors } = useContextState()
  return ({
    boxShadow: `0px 0px 4px ${colors.color13}`,

  })
})

export { NewCard }
